import { useEffect, useState } from "react";
import { useApiInfoContextValueHook } from "../../../../../../../contexts/ApiInfoContextProvider";
import { SellertoolSignatureUtils } from "../../../../../../../utils/sellertool-signature-utils";
import { CustomBackdropController } from "../../../../../../../components/backdrop/default/v1";
import axios from "axios";
import { customToast } from "../../../../../../../components/toast/custom-react-toastify/v1";
import styled from 'styled-components';
import { CustomDialog } from "../../../../../../../components/dialog/v1/CustomDialog";
import CustomBlockButton from "../../../../../../../components/button/CustomBlockButton";
import { CustomLabelInput } from "../../../../../../../components/input/CustomLabelInput";
import { WegetAddressList } from "./wegets/weget-address-list";
import { WegetSetting } from "./wegets/weget-setting";

const API_HOST = process.env.REACT_APP_MAIN_API_HOST;

const StyledHeader = styled.div`
    padding: 10px;
`;

const StyledBody = styled.div`
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .inputField{
        display: flex;
        gap: 10px;

        select{
            flex:1;
            border: 1px solid #333;
            padding: 10px;
            border-radius: 5px;
            background-color: #fff;
            font-size: 14px;
            outline: none;

            &:hover{
                scale: 1.05;
            }
        }
    }
`;

export function EditRackLocationAddressModal({
    open,
    onClose,
    editTargetPallet,
    pallets,
    loadItems,
    onReqFetch,
    apiResource = 'pallets'
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();

    const [viewMode, setViewMode] = useState('DEFAULT'); // DEFAULT, SETTING
    const [rackLocations, setRackLocations] = useState(null);
    const [addressSearchQueryDatas, setAddressSearchQueryDatas] = useState({
        rack: '',
        bay: '',
        level: '',
        position: '',
    });
    const [selectedRackLocation, setSelectedRackLocation] = useState(null);

    useEffect(() => {
        handleFetchRackLocationAddresses();
    }, []);

    const handleFetchRackLocationAddresses = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        CustomBackdropController().showBackdrop();
        const enabledLocationsFetchResult = await axios.get(`${API_HOST}/rack-locations`, {
            headers: headers,
            params: {
                type: 'INVENTORY',
                // enabledYn: 'y'
            }
        })
            .then(res => {
                return {
                    res: res,
                    content: res.data?.content
                }
            })
            .catch(err => {
                customToast.error(err.response);
            })

        let enabledLocations;
        if (enabledLocationsFetchResult?.content) {
            enabledLocations = enabledLocationsFetchResult?.content;
            enabledLocations.sort((a, b) => {
                const aSplit = a?.address?.split('-');
                const bSplit = b?.address?.split('-');
                if (`${aSplit[3]}_${aSplit[1]}_${aSplit[2]}_${aSplit[4]}` < `${bSplit[3]}_${bSplit[1]}_${bSplit[2]}_${bSplit[4]}`) return -1;
                if (`${aSplit[3]}_${aSplit[1]}_${aSplit[2]}_${aSplit[4]}` > `${bSplit[3]}_${bSplit[1]}_${bSplit[2]}_${bSplit[4]}`) return 1;
                return 0;
            })
        }

        setRackLocations(enabledLocations);
        CustomBackdropController().hideBackdrop();
    }

    const handleSelect = (rackLocation) => {
        setSelectedRackLocation(rackLocation)
        setViewMode('SETTING');
    };

    const handleChangeAddressSearchQueryDatas = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        setAddressSearchQueryDatas(prev => {
            return {
                ...prev,
                [name]: value
            }
        })
    }

    const filteredRackLocations = rackLocations?.filter(location => {
        const addressSplit = location?.address?.split('-');
        const centerNumber = addressSplit[0];
        const rackNumber = addressSplit[1];
        const bayNumber = addressSplit[2];
        const levelNumber = addressSplit[3];
        const positionNumber = addressSplit[4];

        if (rackNumber?.toLowerCase().includes(addressSearchQueryDatas?.rack.toLowerCase()) &&
            bayNumber?.toLowerCase().includes(addressSearchQueryDatas?.bay.toLowerCase()) &&
            levelNumber?.toLowerCase().includes(addressSearchQueryDatas?.level.toLowerCase()) &&
            positionNumber?.toLowerCase().includes(addressSearchQueryDatas?.position.toLowerCase())) {
            return true;
        }
        return false;
    });

    return (
        <CustomDialog
            open={open}
        >
            <StyledHeader>
                <CustomDialog.Header>
                    <CustomDialog.Header.Fake />
                    <CustomDialog.Header.Fake />
                    <CustomDialog.Header.Close onClick={() => onClose()} />
                </CustomDialog.Header>
            </StyledHeader>
            {viewMode === 'DEFAULT' &&
                <StyledBody>
                    <div className='inputField'>
                        <select value={addressSearchQueryDatas?.rack} name='rack' onChange={(e) => handleChangeAddressSearchQueryDatas(e)}>
                            <option value=''>랙</option>
                            <option value='A'>A</option>
                            <option value='B'>B</option>
                            <option value='C'>C</option>
                            <option value='D'>D</option>
                        </select>
                        <select value={addressSearchQueryDatas?.bay} name='bay' onChange={(e) => handleChangeAddressSearchQueryDatas(e)}>
                            <option value=''>베이</option>
                            <option value='01'>01</option>
                            <option value='02'>02</option>
                            <option value='03'>03</option>
                            <option value='04'>04</option>
                            <option value='05'>05</option>
                            <option value='06'>06</option>
                            <option value='07'>07</option>
                            <option value='08'>08</option>
                            <option value='09'>09</option>
                            <option value='10'>10</option>
                        </select>
                        <select value={addressSearchQueryDatas?.level} name='level' onChange={(e) => handleChangeAddressSearchQueryDatas(e)}>
                            <option value=''>레벨</option>
                            <option value='A'>A</option>
                            <option value='B'>B</option>
                            <option value='C'>C</option>
                            <option value='D'>D</option>
                        </select>
                        <select value={addressSearchQueryDatas?.position} name='position' onChange={(e) => handleChangeAddressSearchQueryDatas(e)}>
                            <option value=''>포지션</option>
                            <option value='01'>01</option>
                            <option value='02'>02</option>
                        </select>
                    </div>

                    <WegetAddressList
                        filteredRackLocations={filteredRackLocations}
                        onSelect={handleSelect}
                    />
                </StyledBody>
            }
            {viewMode === 'SETTING' &&
                <StyledBody>
                    <WegetSetting
                        editTargetPallet={editTargetPallet}
                        pallets={pallets}
                        loadItems={loadItems}
                        selectedRackLocation={selectedRackLocation}
                        onPrevToDefault={() => {
                            setViewMode('DEFAULT');
                            setSelectedRackLocation(null);
                        }}
                        onCloseModal={() => { onClose(); }}
                        onReqFetch={onReqFetch}
                        apiResource={apiResource}
                    />
                </StyledBody>
            }
        </CustomDialog>
    );
}